import { render, staticRenderFns } from "./Recap.vue?vue&type=template&id=94971136&scoped=true"
import script from "./Recap.ts?vue&type=script&lang=ts&external"
export * from "./Recap.ts?vue&type=script&lang=ts&external"
import style0 from "./Recap.scss?vue&type=style&index=0&id=94971136&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94971136",
  null
  
)

export default component.exports